import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import LabeledDropdown from './LabeledDropdown';
import { getPersonalizationLabelWithPrice } from '../utils/ProductUtils';
import { mapContextToProps } from '../../components/OlsShopContext';

export class PersonalizationOption extends React.Component {
  constructor() {
    super(...arguments);

    this.handleChange = this.handleChange.bind(this);
  }

  renderOptionValues() {
    const translate = this.props.translate || (() => {});
    var optionValues = this.props.option_values || [];
    var output = [];

    output.push(<option value='select'>{ translate('products.option_select') }</option>);
    optionValues.forEach(function (ov) {
      const optionText = getPersonalizationLabelWithPrice({
        name: ov.name,
        price: ov.increase_by,
        translate
      });
      output.push(
        <option key={ 'personalization-option-' + ov.id } value={ ov.id }>
          { optionText }
        </option>
      );
    });

    return output;
  }

  handleChange(e) {
    const id = this.props.id;
    const val = e.target.value;
    const enabled = this.props.required || (val !== '' && val !== null && val !== 'select');
    this.props.onChange(id, enabled, val);
  }

  render() {
    const fieldId = 'personalization-select-' + this.props.id;
    const translate = this.props.translate || (() => {});
    const { Form } = UX2.Group;

    let labelText = this.props.name;
    if (!this.props.required) {
      labelText = translate('products.optional_label_text', {
        name: labelText
      });
    }

    return (
      <Form.Group style={{ marginBottom: 'medium' }}>
        <LabeledDropdown
          labelText={ labelText }
          labelError={ this.props.labelError }
          id={ fieldId }
          onChange={ this.handleChange }
          children={ this.renderOptionValues() }
        />
      </Form.Group>
    );
  }
}

PersonalizationOption.propTypes = {
  onChange: PropTypes.func,
  labelError: PropTypes.bool,
  option_values: PropTypes.array,
  required: PropTypes.bool,
  id: PropTypes.any,
  name: PropTypes.any,
  translate: PropTypes.func
};

PersonalizationOption.defaultProps = {
  labelError: false,
  onChange: function () {}
};

export default mapContextToProps(PersonalizationOption, context => ({
  translate: context.translate
}));
